import React from 'react';

export default function EmailGateway() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Email Gateway</h1>
      <p className="text-gray-500">Halaman Email Gateway</p>
    </div>
  );
}
